import React, { useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { TextContext } from '@/utils/contexts/TextContext';

const LetterInfo = () => {
	const { dict } = useSelector((state) => state.app);

	const { contextState } = useContext(TextContext);

	const { recipientsDict, categoriesDict } = useSelector(state => state.data);

	const getDateSpan = useCallback((dateString) => {
		if (!dateString || dateString.length < 1) return '';
		return (
			<span style={ { whiteSpace: 'nowrap' } }>
				{dateString.replace('T', ', ').replaceAll('-', '.')}
			</span>
		);
	}, []);
	return (
		<section className='letter__info'>
			{contextState.letterData && (
				<div className='letter__info--inner'>
					<div className='letter__info--bar'>
						{ contextState.letterData.date && (
							<div className='letter__info--item'>
								{dict.letter.info.date}
								{getDateSpan(contextState.letterData.date)}
							</div>
						)}						
						{contextState.letterData.author && (
							<div className='letter__info--item'>
								{dict.letter.info.author}<span>{`${contextState.letterData.author.forename} ${contextState.letterData.author.surname}`}</span>
							</div>
						)}
						<div className='letter__info--item'>
							{dict.letter.info.department}<span>{contextState.letterData.department.name}</span>
						</div>
						<div className='letter__info--item'>
							{dict.letter.info.recipient}<span>{recipientsDict[contextState.letterData.recipient.code]}</span>
						</div>
						{ contextState.letterData.category && (
							<div className='letter__info--item'>
								{dict.letter.categories.category}: 
								<span> {categoriesDict[contextState.letterData.category.code]}</span>
							</div>
						)}
					</div>
					<div className='letter__info--bar right'>
						<div className='letter__info--item'>
							{dict.letter.info.initiator}<span>{`${contextState.letterData.owner.forename} ${contextState.letterData.owner.surname}, ${contextState.letterData.owner.email}`}</span>
						</div>
						<div className='letter__info--item'>
							{dict.letter.info.addDate}
							{getDateSpan(contextState.letterData.createdOn)}
						</div>
						<div className='letter__info--item'>
							{dict.letter.info.editDate}{getDateSpan(contextState.letterData.modifiedOn)}
						</div>
					</div>
				</div>
			)}
		</section>
	);
};
export default React.memo(LetterInfo);